module.exports = __webpack_public_path__ + "img/RECHERCHER_INDIVIDU_ACTIVE.fab5817c.svg";